import data from '../../data/data-containers/data-Home'
import dataJson from '../../data/data-containers/data-Home.json'
import {
  iconsGift
} from "../../utils/allImgs"
import SEO from "../../components/Seo"
import Headings from "./Headings"
import InfosAndNumbers from "./InfosAndNumbers"
import NewNFTs from "../../components/NewNFTs"
import HowItWorks from "../../components/HowItWorks"

const HomeContainer = () => {

  return (
    <>
      <SEO title="Market NFTs" />
      <main>
        <Headings data={data[0].dataHeadings} />
        <div className="moving-bg" />
        <div className="moving-bg-2" />
        <InfosAndNumbers data={dataJson[0].dataInfosAndNumbers} />
        <NewNFTs data={data[0].NewNFTs} />
        <HowItWorks title={dataJson[0].HowItWorks} data={data[0].HowItWorks} />
      </main>
    </>
  );
}

export default HomeContainer;